<template>
  <!-- <<<<<<< HEAD
  <div class="form-row" v-if="!isdeleted">
    <div class="col-md-2 mb-3">
      <v-text-field
        :label="$t('models.nguyenVong.stt')"
        outlined
        dense
        readonly
        :value="stt + 1"
      >
      </v-text-field>
    </div>
    <div class="col-md-2 mb-3">
      <validation-provider
        v-slot="{ errors, valid }"
        :name="$t('models.nguyenVong.coSo')"
        rules="required"
      >
        <v-select
          :id="`coSo${stt}`"
          :items="cosoes"
          :item-value="(item) => item.coSoId"
          :item-text="(item) => `${item.maCoSo} - ${item.tenCoSo}`"
          :label="$t('models.nguyenVong.coSo')"
          outlined
          dense
          required
          :success="valid === true"
          :is-valid="!!coSoId"
          :append-icon="
            valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
          "
          :error="errors[0] ? true : false"
          :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          v-model="coSoId"
        ></v-select>
        <span class="text-danger">{{ errors[0] }}</span>
      </validation-provider>
    </div>

    <div class="col-md-4 mb-3">
======= -->
  <div v-if="loaiDot != 'THI'">
    <div class="form-row" v-if="!isdeleted">
      <div class="col-md-2 mb-3">
        <v-text-field
          :label="$t('models.nguyenVong.stt')"
          outlined
          dense
          readonly
          :value="stt + 1"
        >
        </v-text-field>
      </div>

      <div class="col-md-2 mb-3">
        <validation-provider
          v-slot="{ errors, valid }"
          :name="$t('models.nguyenVong.coSo')"
          rules="required"
        >
          <v-select
            :id="`coSo${stt}`"
            :items="cosoes"
            :item-value="(item) => item.coSoId"
            :item-text="(item) => `${item.maCoSo} - ${item.tenCoSo}`"
            :label="$t('models.nguyenVong.coSo')"
            outlined
            dense
            required
            :success="valid === true"
            :is-valid="!!coSoId"
            :append-icon="
              valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
            "
            :error="errors[0] ? true : false"
            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
            v-model="coSoId"
          ></v-select>
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div class="col-md-4 mb-3">
        <validation-provider
          v-slot="{ errors, valid }"
          :name="$t('models.nguyenVong.name')"
          rules="required"
        >
          <v-autocomplete
            :id="`cbNganh${stt}`"
            :items="nganhByCoSoes"
            :item-value="(item) => item.nganhId"
            :item-text="(item) => `${item.maNganh} - ${item.tenNganh}`"
            :label="$t('models.nganh.maNganh')"
            outlined
            dense
            required
            :success="valid === true"
            :is-valid="!!nguyenvong.nganhId"
            :append-icon="
              valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
            "
            :error="errors[0] ? true : false"
            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
            v-model="nguyenvong.nganhId"
            @change="getNganhTopHop"
          ></v-autocomplete>
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="col-md-3 mb-3">
        <validation-provider
          v-slot="{ errors, valid }"
          :name="$t('models.nguyenVong.toHop', { stt: stt + 1 })"
          rules="required"
        >
          <v-select
            :id="`cbToHop${stt}`"
            :items="tohops"
            :item-value="(item) => item.toHopId"
            :item-text="(item) => `${item.maToHop} (${item.tenToHop})`"
            label="Tổ hợp"
            outlined
            dense
            required
            :success="valid === true"
            :is-valid="!!nguyenvong.toHopId"
            :append-icon="
              valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
            "
            :error="errors[0] ? true : false"
            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
            v-model="nguyenvong.toHopId"
            @change="khaiBaoDiem"
          ></v-select>
          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="col-md-1" v-if="length > 1">
        <v-btn
          :name="`deleteNguyenVong${stt}`"
          class="mx-2"
          fab
          dark
          small
          color="error"
          @click="deleteNguyenVong"
        >
          <v-icon dark>mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-md-2 mb-3">
      <validation-provider
        v-slot="{ errors, valid }"
        :name="$t('models.nguyenVong.coSo')"
        rules="required"
      >
        <v-select
          :id="`coSo${stt}`"
          :items="cosoes"
          :item-value="(item) => item.coSoId"
          :item-text="(item) => `${item.maCoSo} - ${item.tenCoSo}`"
          :label="$t('models.nguyenVong.coSo')"
          outlined
          dense
          required
          :success="valid === true"
          :is-valid="!!coSoId"
          :append-icon="
            valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
          "
          :error="errors[0] ? true : false"
          :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          v-model="coSoId"
        ></v-select>
        <span class="text-danger">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div class="col-md-6 mb-3">
      <validation-provider
        v-slot="{ errors, valid }"
        :name="$t('models.nguyenVong.name')"
        rules="required"
      >
        <v-autocomplete
          :id="`cbNganh${stt}`"
          :items="nganhByCoSoes"
          :item-value="(item) => item.nganhId"
          :item-text="(item) => `${item.maNganh} - ${item.tenNganh}`"
          :label="$t('models.nganh.maNganh')"
          outlined
          dense
          required
          :success="valid === true"
          :is-valid="!!nguyenvong.nganhId"
          :append-icon="
            valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
          "
          :error="errors[0] ? true : false"
          :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          v-model="nguyenvong.nganhId"
          @change="getNganhTopHop"
        ></v-autocomplete>
        <span class="text-danger">{{ errors[0] }}</span>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import NguyenVong from "../js/nguyenvong";
export default NguyenVong;
</script>

<style lang="scss" scoped></style>
